import Vue from "vue"
import axios from "axios"

import countriesList from "@/assets/data/country_names"
import localeOptionsList from "@/assets/data/locale_options"
import currencyOptionsList from "@/assets/data/currency_options"
import { getNowDateString } from "@/utils/date"

const initialState = {
  locale: {},
  window: { focused: true, width: window.innerWidth },
  loading: {
    active: false,
    progress: null
  },

  notifications: {
    active: false,
    type: null,
    content: {
      title: null,
      message: null,
      structure: null,
      item: null
    }
  },
  modal: {
    content: {},
    active: false
  },
  site: {},
  localeOptions: localeOptionsList,
  currencyOptions: currencyOptionsList,
  countries: countriesList,
  api: {
    link: undefined,
    payload: undefined
  },
  menuMobile: {
    toggle: false
  },

  acordeon: {
    active: false,
    index: undefined
  }
}

const state = Object.assign({}, initialState)

const getters = {
  locale: (state) => state.locale,
  //backlinks: (state) => state.backlinks,
  multiLocale: (state) => state.multiLocale,
  loading: (state) => state.loading,
  window: (state) => state.window,
  notifications: (state) => state.notifications,
  modal: (state) => state.modal,
  site: (state) => state.site,
  countries: (state) => state.countries,
  menuMobile: (state) => state.menuMobile,
  acordeon: (state) => state.acordeon,
  generalIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  }
}

const actions = {
  UPDATE_general({ commit }, payload) {
    commit("SET_general", payload)
    return true
  },
  CHANGE_LOCALE({ commit }, locale) {
    localStorage.setItem("locale-id", locale.id)
    axios.defaults.headers.common["locale-id"] = `${locale.id}`
    commit("SET_LOCALE", locale)
  },
  async CLEAN_STORE_general({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_general", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  INIT_site({ commit }, payload) {
    commit("SET_SITE", payload)
    return true
  },

  DOWNLOAD_api({ state, getters }) {
    const link = state.api.link
    const payload = state.api.payload
    const site = getters.site
    const domain = site?.domain

    const config = {
      headers: domain ? { domain } : {},
      responseType: "blob"
    }

    const request = payload
      ? axios.post(link, payload, config)
      : axios.get(link, config)

    return request
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"]
        let filename = "download"
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          )
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, "")
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const a = document.createElement("a")
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
        return response.data
      })
      .catch(() => {
        return null
      })
  },

  GET_NOW_DATE_STRING() {
    const dateString = getNowDateString()
    return dateString
  }
}

const mutations = {
  SET_LOCALE: (state, locale) => {
    state.locale = locale
  },
  SET_SITE: (state, site) => {
    state.site = site
  },
  SET_general: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
